'use server'

import WebsphereService from '@/features/websphere/websphere-service'
import { isFeatureEnabled } from '@/utils/environment/actions/feature-flags'
import { Logger } from '@/utils/logging/logger'

const logger = new Logger('src/features/agent/actions/forgot-password')

export async function forgotPassword(username: string) {
	const resetPasswordV2Activated = await isFeatureEnabled('ENABLE_RESET_PASSWORD_V2')
	if (resetPasswordV2Activated) {
		//await resetPasswordOnDts(username)
		await unlockUserOnWebsphere(username)
		return
	}

	await checkUserFieldPwd(username)
	await invokeAjaxPersonChangeServicePasswordReset(username)
}

interface AjaxCheckUserFieldPwdCmdResponseType {
	usersField1: 'NOUSER' | 'NOPWD' | 'YES'
}

async function checkUserFieldPwd(username: string): Promise<void> {
	const response: AjaxCheckUserFieldPwdCmdResponseType = await WebsphereService.get({
		command: 'AjaxCheckUserFieldPwdCmd',
		market: 'current',
		request: {
			usersId: username,
		},
	})

	if (response.usersField1 === 'NOUSER') {
		logger.error(`User ${username} doesn't exist on commerce side`)
		throw new Error()
	}
}

interface AjaxPersonChangeServicePasswordResetResponseType {
	userId: string
}

async function invokeAjaxPersonChangeServicePasswordReset(username: string): Promise<void> {
	const response: AjaxPersonChangeServicePasswordResetResponseType = await WebsphereService.get({
		command: 'AjaxPersonChangeServicePasswordReset',
		market: 'current',
		request: {
			challengeAnswer: '-',
			state: 'passwdconfirm',
			logonId: username,
		},
	})

	if (typeof response.userId === 'number') {
		logger.error(`An error occured during the execution of the command AjaxPersonChangeServicePasswordReset for user ${username}`)
		throw new Error(`An error occured during the execution of the command AjaxPersonChangeServicePasswordReset for user ${username}`)
	}
}

async function unlockUserOnWebsphere(username: string): Promise<void> {
	const response: any = await WebsphereService.get({
		command: 'ResetUser',
		market: 'current',
		request: {
			user: username,
		},
	})

	if (response?.result !== 'ok') {
		const message = `An error occured during the unlock of the user ${username} on websphere side`
		logger.error(message)
		throw new Error(message)
	}
}

/* async function resetPasswordOnDts(username: string): Promise<void> {
	const url = getEnv('RESET_PASSWORD_ENDPOINT')
	if (!url) {
		logger.error('The environment variable RESET_PASSWORD_ENDPOINT is not set')
		throw new Error('The environment variable RESET_PASSWORD_ENDPOINT is not set')
	}

	const base64Username = Buffer.from(`${username}:`).toString('base64')
	const response = await fetchWithTimeout(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Basic ${base64Username}`,
		},
		body: JSON.stringify({
			rqtype: 'RESET',
			entity: 'REP',
		}),
	})

	const responseBody = (await response.json()) as DtsResetPasswordResponse

	if (response.status !== 200 || responseBody.type !== 'SUCCESS') {
		logger.error(`An error occured during the execution of the command ResetPassword for user ${username}. Response: ${JSON.stringify(response)}`)
		throw new Error(`An error occured during the execution of the command ResetPassword`)
	}
	logger.info(`Password reset for user ${username} on DTS side`)
} */
